module.exports = __webpack_public_path__ + "static/pendencias-logo-9779e8f8d772b214df52bd503fd086f0.jpg";